/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkStartRequest } from '../models/BulkStartRequest';
import type { BulkStartResponse } from '../models/BulkStartResponse';
import type { CampaignCopyRequest } from '../models/CampaignCopyRequest';
import type { CampaignCreate } from '../models/CampaignCreate';
import type { CampaignExportBundle } from '../models/CampaignExportBundle';
import type { CampaignImportRequest } from '../models/CampaignImportRequest';
import type { CampaignImportResult } from '../models/CampaignImportResult';
import type { CampaignResponse } from '../models/CampaignResponse';
import type { CampaignSecretResponse } from '../models/CampaignSecretResponse';
import type { CampaignSecretSetRequest } from '../models/CampaignSecretSetRequest';
import type { CampaignTransferRequest } from '../models/CampaignTransferRequest';
import type { CampaignUpdate } from '../models/CampaignUpdate';
import type { ContactBulkDeleteRequest } from '../models/ContactBulkDeleteRequest';
import type { ContactCreate } from '../models/ContactCreate';
import type { ContactResponse } from '../models/ContactResponse';
import type { ContactStateResponse } from '../models/ContactStateResponse';
import type { ContactUpdate } from '../models/ContactUpdate';
import type { DynamicMonitoringResponse } from '../models/DynamicMonitoringResponse';
import type { HumanInputRequest } from '../models/HumanInputRequest';
import type { HumanInputResponse } from '../models/HumanInputResponse';
import type { LlmDefaultModelResponse } from '../models/LlmDefaultModelResponse';
import type { LlmTestModelRequest } from '../models/LlmTestModelRequest';
import type { LlmTestModelResponse } from '../models/LlmTestModelResponse';
import type { PaginatedCampaignMonitoringResponse } from '../models/PaginatedCampaignMonitoringResponse';
import type { PaginatedCampaignsResponse } from '../models/PaginatedCampaignsResponse';
import type { PaginatedContactsResponse } from '../models/PaginatedContactsResponse';
import type { PaginatedMessageHistoryResponse } from '../models/PaginatedMessageHistoryResponse';
import type { PaginatedPromptsResponse } from '../models/PaginatedPromptsResponse';
import type { PaginatedTasksResponse } from '../models/PaginatedTasksResponse';
import type { PromptCreate } from '../models/PromptCreate';
import type { PromptResponse } from '../models/PromptResponse';
import type { PromptUpdate } from '../models/PromptUpdate';
import type { TaskResponse } from '../models/TaskResponse';
import type { TaskUpdate } from '../models/TaskUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminApiService {
    /**
     * Get Tasks
     * @param contactId
     * @param campaignId
     * @param status
     * @param taskType
     * @param search Match against the contact's name, email, or phone.
     * @param sort Sort field and direction, e.g. 'scheduled_at:desc', 'status:asc'. Sortable fields: scheduled_at, created_at, updated_at, executed_at, status, task_type.
     * @param limit
     * @param offset
     * @returns PaginatedTasksResponse Successful Response
     * @throws ApiError
     */
    public static getTasksApiAdminTasksGet(
        contactId?: (string | null),
        campaignId?: (string | null),
        status?: (string | null),
        taskType?: (string | null),
        search?: (string | null),
        sort?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/tasks',
            query: {
                'contact_id': contactId,
                'campaign_id': campaignId,
                'status': status,
                'task_type': taskType,
                'search': search,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Task
     * @param taskId
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static getTaskApiAdminTasksTaskIdGet(
        taskId: string,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Task
     * @param taskId
     * @param requestBody
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static updateTaskApiAdminTasksTaskIdPatch(
        taskId: string,
        requestBody: TaskUpdate,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Task
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTaskApiAdminTasksTaskIdDelete(
        taskId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contacts
     * @param email
     * @param phone
     * @param campaignId
     * @param requiresHumanInput
     * @param search
     * @param latestContactState
     * @param updatedFrom
     * @param updatedTo
     * @param sort Sort field and direction, e.g. 'created_at:desc', 'email:asc'. Sortable fields: created_at, updated_at, email, first_name, last_name, phone
     * @param limit
     * @param offset
     * @returns PaginatedContactsResponse Successful Response
     * @throws ApiError
     */
    public static getContactsApiAdminContactsGet(
        email?: (string | null),
        phone?: (string | null),
        campaignId?: (string | null),
        requiresHumanInput?: (boolean | null),
        search?: (string | null),
        latestContactState?: (string | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        sort?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedContactsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts',
            query: {
                'email': email,
                'phone': phone,
                'campaign_id': campaignId,
                'requires_human_input': requiresHumanInput,
                'search': search,
                'latest_contact_state': latestContactState,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Contact
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static createContactApiAdminContactsPost(
        requestBody: ContactCreate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Contacts Csv
     * @param campaignId Campaign ID (required)
     * @param email
     * @param phone
     * @param requiresHumanInput
     * @param search
     * @param latestContactState
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportContactsCsvApiAdminContactsExportCsvGet(
        campaignId: string,
        email?: (string | null),
        phone?: (string | null),
        requiresHumanInput?: (boolean | null),
        search?: (string | null),
        latestContactState?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/export-csv',
            query: {
                'campaign_id': campaignId,
                'email': email,
                'phone': phone,
                'requires_human_input': requiresHumanInput,
                'search': search,
                'latest_contact_state': latestContactState,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Contacts
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bulkDeleteContactsApiAdminContactsBulkDeletePost(
        requestBody: ContactBulkDeleteRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/bulk-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Start Contacts
     * @param requestBody
     * @returns BulkStartResponse Successful Response
     * @throws ApiError
     */
    public static bulkStartContactsApiAdminContactsBulkStartPost(
        requestBody: BulkStartRequest,
    ): CancelablePromise<BulkStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/bulk-start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact By Email
     * @param email
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactByEmailApiAdminContactsByEmailEmailDelete(
        email: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contacts/by-email/{email}',
            path: {
                'email': email,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact
     * @param contactId
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static getContactApiAdminContactsContactIdGet(
        contactId: string,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Contact
     * @param contactId
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static updateContactApiAdminContactsContactIdPatch(
        contactId: string,
        requestBody: ContactUpdate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact
     * @param contactId
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactApiAdminContactsContactIdDelete(
        contactId: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clean Contact Data
     * @param contactId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cleanContactDataApiAdminContactsContactIdCleanPost(
        contactId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/{contact_id}/clean',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact State
     * @param contactId
     * @returns ContactStateResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateApiAdminContactsContactIdStateGet(
        contactId: string,
    ): CancelablePromise<Array<ContactStateResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}/state',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Message History
     * @param contactId
     * @param limit
     * @param offset
     * @param channel
     * @returns PaginatedMessageHistoryResponse Successful Response
     * @throws ApiError
     */
    public static getMessageHistoryApiAdminContactsContactIdMessageHistoryGet(
        contactId: string,
        limit: number = 50,
        offset?: number,
        channel?: (string | null),
    ): CancelablePromise<PaginatedMessageHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}/message-history',
            path: {
                'contact_id': contactId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'channel': channel,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Distinct Contact States
     * @param campaignId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getDistinctContactStatesApiAdminContactStatesDistinctGet(
        campaignId?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contact-states/distinct',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompts
     * @param promptType
     * @param campaignId
     * @param isActive
     * @param limit
     * @param offset
     * @returns PaginatedPromptsResponse Successful Response
     * @throws ApiError
     */
    public static getPromptsApiAdminPromptsGet(
        promptType?: (string | null),
        campaignId?: (string | null),
        isActive?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedPromptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/prompts',
            query: {
                'prompt_type': promptType,
                'campaign_id': campaignId,
                'is_active': isActive,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Prompt
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static createPromptApiAdminPromptsPost(
        requestBody: PromptCreate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/prompts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompt
     * @param promptId
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static getPromptApiAdminPromptsPromptIdGet(
        promptId: string,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Prompt
     * @param promptId
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static updatePromptApiAdminPromptsPromptIdPatch(
        promptId: string,
        requestBody: PromptUpdate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Prompt
     * @param promptId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePromptApiAdminPromptsPromptIdDelete(
        promptId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Llm Default Model
     * @returns LlmDefaultModelResponse Successful Response
     * @throws ApiError
     */
    public static getLlmDefaultModelApiAdminLlmDefaultModelGet(): CancelablePromise<LlmDefaultModelResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/llm/default-model',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Test Llm Model
     * Probe a model with the system or campaign-scoped OpenRouter key.
     * @param requestBody
     * @param campaignId
     * @returns LlmTestModelResponse Successful Response
     * @throws ApiError
     */
    public static testLlmModelApiAdminLlmTestModelPost(
        requestBody: LlmTestModelRequest,
        campaignId?: (string | null),
    ): CancelablePromise<LlmTestModelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/llm/test-model',
            query: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Campaign Secrets
     * @param campaignId
     * @returns CampaignSecretResponse Successful Response
     * @throws ApiError
     */
    public static listCampaignSecretsApiAdminCampaignsCampaignIdSecretsGet(
        campaignId: string,
    ): CancelablePromise<Array<CampaignSecretResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}/secrets',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Secret
     * @param campaignId
     * @param keyName
     * @returns CampaignSecretResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNameGet(
        campaignId: string,
        keyName: string,
    ): CancelablePromise<CampaignSecretResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}/secrets/{key_name}',
            path: {
                'campaign_id': campaignId,
                'key_name': keyName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Campaign Secret
     * @param campaignId
     * @param keyName
     * @param requestBody
     * @returns CampaignSecretResponse Successful Response
     * @throws ApiError
     */
    public static setCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNamePut(
        campaignId: string,
        keyName: string,
        requestBody: CampaignSecretSetRequest,
    ): CancelablePromise<CampaignSecretResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/campaigns/{campaign_id}/secrets/{key_name}',
            path: {
                'campaign_id': campaignId,
                'key_name': keyName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign Secret
     * @param campaignId
     * @param keyName
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNameDelete(
        campaignId: string,
        keyName: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/campaigns/{campaign_id}/secrets/{key_name}',
            path: {
                'campaign_id': campaignId,
                'key_name': keyName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaigns
     * @param status
     * @param limit
     * @param offset
     * @returns PaginatedCampaignsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignsApiAdminCampaignsGet(
        status?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignApiAdminCampaignsPost(
        requestBody: CampaignCreate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign
     * Get a single campaign by id, including secrets metadata (no plaintext).
     * @param campaignId
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignApiAdminCampaignsCampaignIdGet(
        campaignId: string,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignApiAdminCampaignsCampaignIdPatch(
        campaignId: string,
        requestBody: CampaignUpdate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignApiAdminCampaignsCampaignIdDelete(
        campaignId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static copyCampaignApiAdminCampaignsCampaignIdCopyPost(
        campaignId: string,
        requestBody?: (CampaignCopyRequest | null),
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/{campaign_id}/copy',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static transferCampaignApiAdminCampaignsCampaignIdTransferPost(
        campaignId: string,
        requestBody: CampaignTransferRequest,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/{campaign_id}/transfer',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaign
     * Export a campaign settings, prompts and secret-key placeholders as JSON
     * @param campaignId
     * @returns CampaignExportBundle Successful Response
     * @throws ApiError
     */
    public static exportCampaignApiAdminCampaignsCampaignIdExportGet(
        campaignId: string,
    ): CancelablePromise<CampaignExportBundle> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}/export',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Campaign
     * Create a new campaign in the caller's organization from a bundle
     * produced by :func:`export_campaign`. The bundle's ``schema_version``
     * must match the server's supported version.
     * @param requestBody
     * @returns CampaignImportResult Successful Response
     * @throws ApiError
     */
    public static importCampaignApiAdminCampaignsImportPost(
        requestBody: CampaignImportRequest,
    ): CancelablePromise<CampaignImportResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaign Admin
     * Kick off a campaign for a contact (admin endpoint).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startCampaignAdminApiAdminCampaignsStartPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Monitoring
     * @param campaignId
     * @param search
     * @param latestContactState
     * @param sort Sort field and direction, e.g. 'contact_name:asc', 'latest_contact_state:desc'. Sortable fields: contact_name, contact_email, contact_phone, campaign_name, created_at, latest_contact_state, next_task_time.
     * @param updatedFrom
     * @param updatedTo
     * @param limit
     * @param offset
     * @returns PaginatedCampaignMonitoringResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMonitoringApiAdminCampaignMonitoringGet(
        campaignId?: (string | null),
        search?: (string | null),
        latestContactState?: (string | null),
        sort?: (string | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaign-monitoring',
            query: {
                'campaign_id': campaignId,
                'search': search,
                'latest_contact_state': latestContactState,
                'sort': sort,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Monitoring Dynamic
     * @param campaignId
     * @param search
     * @param latestContactState
     * @param sort Sort field and direction, e.g. 'contact_name:asc', 'latest_contact_state:desc'. Sortable fields: contact_name, contact_email, contact_phone, campaign_name, created_at, latest_contact_state, next_task_time.
     * @param updatedFrom
     * @param updatedTo
     * @param limit
     * @param offset
     * @returns DynamicMonitoringResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMonitoringDynamicApiAdminCampaignMonitoringDynamicGet(
        campaignId?: (string | null),
        search?: (string | null),
        latestContactState?: (string | null),
        sort?: (string | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<DynamicMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaign-monitoring/dynamic',
            query: {
                'campaign_id': campaignId,
                'search': search,
                'latest_contact_state': latestContactState,
                'sort': sort,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Human Input
     * @param requestBody
     * @returns HumanInputResponse Successful Response
     * @throws ApiError
     */
    public static submitHumanInputApiAdminHumanInputPost(
        requestBody: HumanInputRequest,
    ): CancelablePromise<HumanInputResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/human-input',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Integration Info
     * Return integration info (API key) for external systems like N8N.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getIntegrationInfoApiAdminIntegrationInfoGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/integration-info',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
